/* msd-bc (v44-1): calea din breadcrumb = drumul REAL al clientului prin meniu.
   1) Click în meniu (desktop sau telefon) → reținem lanțul de linkuri al meniului până la colecția aleasă (Militar › Încălțăminte › Bocanci Desert).
   2) Pe pagina colecției lanțul devine „lista curentă”; un click pe o subcategorie din pagină îl prelungește.
      Dacă ajungi pe colecție altfel (căutare, prima pagină), lanțul se ia din locul colecției în meniu.
   3) Pe pagina de produs, dacă produsul e chiar în colecția din care a venit clientul, breadcrumbul arată lanțul ăsta;
      altfel rămâne calea de rezervă trimisă de server (pentru Google / intrări directe).
   Telefon: rând glisabil lateral + bara de derulare + „« înapoi” fix în stânga. */
(function () {
  var K = 'msd_bc', KP = 'msd_bc_p', TTL = 3 * 3600e3;
  function get(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(k, v) { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function path(href) { try { var u = new URL(href, location.href); return u.origin === location.origin ? u.pathname.replace(/\/+$/, '') : null; } catch (e) { return null; } }
  function collHandle(p) { var m = /^\/collections\/([^\/?#]+)(?:\/(?!products\/)[^?#]*)?$/.exec(p || ''); return m ? decodeURIComponent(m[1]) : null; }
  function label(a) {
    var s = a.querySelector('.text') || a;
    var lines = (s.textContent || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean);
    return (lines[0] || '').replace(/🔥/g, '').trim();
  }
  function okLink(a) {
    if (!a || !a.getAttribute) return false;
    var h = a.getAttribute('href') || '';
    if (!h || h.charAt(0) === '#' || /^javascript:/i.test(h)) return false;
    var t = label(a);
    return t && !/^(mergi la|vezi tot|vezi toate|închide|inchide)\b/i.test(t) && !!path(h);
  }
  /* lanțul meniului pentru un link: urcăm prin părinți și luăm „titlul” fiecărui nivel (primul link direct al nivelului) */
  function chainFor(a, tpl) {
    var out = [], seen = {}, e = a, guard = 0;
    function push(x) { var p = path(x.getAttribute('href')); if (!p || seen[p]) return; seen[p] = 1; out.push({ t: label(x), u: p }); }
    push(a);
    while (e && guard++ < 40) {
      if (e.nodeType === 11) { e = tpl || null; continue; }
      if (e.tagName === 'NAV' || e === document.body) break;
      if (e !== a && e.querySelector) {
        var h = e.querySelector(':scope > a[href], :scope > div > a[href], :scope > span > a[href]');
        if (h && h !== a && okLink(h)) push(h);
      }
      e = e.parentNode;
    }
    return out.reverse();
  }
  var MENU = '.header__inline-menu, .site-nav-mobile, .halo-sidebar, .menu-drawer, [data-menu-mobile]';
  function inMenu(a) { return a.closest && a.closest(MENU); }
  /* caută colecția curentă în meniu (inclusiv în meniul mare încă nedesfăcut din <template>) */
  function menuChainForPath(p) {
    var best = null;
    function scan(root, tpl) {
      if (best) return;
      var as = root.querySelectorAll('a[href]');
      for (var i = 0; i < as.length; i++) {
        if (path(as[i].getAttribute('href')) === p && okLink(as[i])) {
          if (!tpl && !inMenu(as[i])) continue;
          best = chainFor(as[i], tpl); return;
        }
      }
    }
    document.querySelectorAll('.header__inline-menu, .site-nav-mobile').forEach(function (r) { scan(r); });
    if (!best) document.querySelectorAll('template.msd-mm').forEach(function (t) { scan(t.content, t); });
    return best;
  }

  /* 1) click-uri */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href]');
    if (!a || !okLink(a)) return;
    var p = path(a.getAttribute('href')), h = collHandle(p);
    if (!h) return;
    if (inMenu(a)) { set(KP, { u: p, c: chainFor(a), t: Date.now() }); return; }
    var cur = get(K), here = collHandle(path(location.href));
    /* click pe un nivel deja din cale (ex. „Pompieri” din breadcrumb) → calea se taie până la el, nu se mai adaugă la coadă */
    if (cur && cur.c) {
      for (var i = 0; i < cur.c.length; i++) if (cur.c[i].u === p) { set(KP, { u: p, c: cur.c.slice(0, i + 1), t: Date.now() }); return; }
    }
    if (a.closest('.msd-bc')) return;
    if (cur && here && cur.h === here && h !== here && !a.closest('header, footer, .header, .footer, .wrapper-footer')) {
      var c = cur.c.slice(0, 5); c.push({ t: label(a), u: p });
      set(KP, { u: p, c: c, t: Date.now() });
    }
  }, true);

  /* 2) pagina de colecție */
  var hereP = path(location.href), hereH = collHandle(hereP);
  if (hereH) {
    var pend = get(KP), cur = get(K), chain = null;
    if (pend && collHandle(pend.u) === hereH && Date.now() - pend.t < 120e3) chain = pend.c;
    else if (cur && cur.h === hereH) chain = cur.c;
    else chain = menuChainForPath('/collections/' + hereH);
    /* curățare: dacă ultimul nivel apare și mai sus în cale (cale greșită salvată), tăiem la prima apariție */
    if (chain && chain.length > 1) { var lu = chain[chain.length - 1].u; for (var j = 0; j < chain.length - 1; j++) if (chain[j].u === lu) { chain = chain.slice(0, j + 1); break; } }
    set(KP, null);
    set(K, chain && chain.length ? { h: hereH, c: chain, list: location.href, t: Date.now() } : null);
  }

  /* 3) pagina de produs */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function initPdp() {
    var nav = document.querySelector('[data-msd-bc]'); if (!nav) return;
    var trail = nav.querySelector('[data-msd-bc-trail]'), cur = get(K);
    var colls = nav.getAttribute('data-colls') || '';
    var isColl = nav.hasAttribute('data-msd-bc-coll');
    var fromList = false;
    if (isColl) {
      /* pagina de colecție: lanțul a fost stabilit mai sus (pasul 2) pentru exact colecția asta */
      if (cur && cur.h === hereH && cur.c && cur.c.length) {
        trail.innerHTML = cur.c.map(function (x, i) { var lst = i === cur.c.length - 1; return '<span class="msd-bc__sep" aria-hidden="true">/</span>' + (lst ? '<span class="msd-bc__cur" aria-current="page">' + esc(x.t) + '</span>' : '<a href="' + esc(x.u) + '">' + esc(x.t) + '</a>'); }).join('');
      }
    } else if (cur && Date.now() - cur.t < TTL && colls.indexOf('|' + cur.h + '|') >= 0) {
      if (cur.c.length > 1) { var lu2 = cur.c[cur.c.length - 1].u; for (var j2 = 0; j2 < cur.c.length - 1; j2++) if (cur.c[j2].u === lu2) { cur.c = cur.c.slice(0, j2 + 1); break; } }
      /* dacă drumul clientului e doar începutul căii de pe server (ex. Militar › Încălțăminte vs. Militar › Încălțăminte › Bocanci Militari),
         păstrăm calea completă, mai precisă – altfel ultimul nivel „dispărea” după o clipă */
      var sp = [].map.call(trail.querySelectorAll('a'), function (x) { return path(x.getAttribute('href')); });
      var isPrefix = sp.length > cur.c.length && cur.c.every(function (x, i) { return x.u === sp[i]; });
      if (!isPrefix) trail.innerHTML = cur.c.map(function (x) { return '<span class="msd-bc__sep" aria-hidden="true">/</span><a href="' + esc(x.u) + '">' + esc(x.t) + '</a>'; }).join('');
      fromList = !!(document.referrer && cur.list && document.referrer.split('#')[0] === cur.list.split('#')[0]);
    }
    var links = trail.querySelectorAll('a'), last = links[links.length - 1];
    if (isColl && trail.querySelector('.msd-bc__cur') == null && links.length > 1) last = links[links.length - 2];
    var sameRef = document.referrer && path(document.referrer) !== null && history.length > 1;
    var back = nav.querySelector('[data-msd-bc-back]');
    back.href = last ? last.getAttribute('href') : '/';
    back.addEventListener('click', function (e) { if (sameRef) { e.preventDefault(); history.back(); } });
    var res = nav.querySelector('[data-msd-bc-res]');
    if (fromList) {
      res.href = cur.list; res.hidden = false;
      res.addEventListener('click', function (e) { if (history.length > 1) { e.preventDefault(); history.back(); } });
    }
    /* telefon: derulat la capăt (se vede categoria cea mai apropiată) + bara de derulare */
    var box = nav.closest('.msd-bc'), thumb = box && box.querySelector('.msd-bc-track i');
    function paint() {
      if (!thumb) return;
      var sw = nav.scrollWidth, cw = nav.clientWidth;
      box.classList.toggle('msd-bc--scroll', sw > cw + 2);
      if (sw <= cw + 2) return;
      var w = Math.max(24, cw / sw * 100);
      thumb.style.width = w + '%';
      thumb.style.left = (nav.scrollLeft / (sw - cw)) * (100 - w) + '%';
    }
    function toEnd() { if (window.matchMedia('(max-width:1024px)').matches) nav.scrollLeft = nav.scrollWidth; paint(); }
    nav.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    toEnd(); setTimeout(toEnd, 300); window.addEventListener('load', toEnd);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp); else initPdp();
})();
